var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18223_273577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8531 4.02744L9.49063 0.664941C9.39688 0.571191 9.27031 0.518066 9.1375 0.518066H2.5C2.22344 0.518066 2 0.741504 2 1.01807V14.0181C2 14.2946 2.22344 14.5181 2.5 14.5181H12.5C12.7766 14.5181 13 14.2946 13 14.0181V4.38213C13 4.24932 12.9469 4.12119 12.8531 4.02744ZM11.8469 4.61182H8.90625V1.67119L11.8469 4.61182ZM11.875 13.3931H3.125V1.64307H7.84375V5.01807C7.84375 5.19211 7.91289 5.35903 8.03596 5.48211C8.15903 5.60518 8.32595 5.67432 8.5 5.67432H11.875V13.3931ZM8 6.89307C8 6.82432 7.94375 6.76807 7.875 6.76807H7.125C7.05625 6.76807 7 6.82432 7 6.89307V8.58057H5.3125C5.24375 8.58057 5.1875 8.63682 5.1875 8.70557V9.45557C5.1875 9.52432 5.24375 9.58057 5.3125 9.58057H7V11.2681C7 11.3368 7.05625 11.3931 7.125 11.3931H7.875C7.94375 11.3931 8 11.3368 8 11.2681V9.58057H9.6875C9.75625 9.58057 9.8125 9.52432 9.8125 9.45557V8.70557C9.8125 8.63682 9.75625 8.58057 9.6875 8.58057H8V6.89307Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18223_273577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.518066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/FileAdd.3fb516b433739581f210bdfc3c9223cc.svg";
export { ForwardRef as ReactComponent };